import { ImgContainer } from './styles';

export const Logo = () => {
  return (
    <ImgContainer>
      <img src='https://cdn.eduzzcdn.com/topbar/sun.svg' alt='Logo checkout sun' />
      <span>Checkout Sun</span>
    </ImgContainer>
  );
};
